import { createContext } from "react";
import type { DashboardOptions } from "../DashboardOptionsProvider.types";

const DashboardOptionsContext = createContext<DashboardOptions | undefined>(undefined);
DashboardOptionsContext.displayName = "DashboardOptionsContext";

export default DashboardOptionsContext;
